<template>
  <section
    ref='container'
    class="page-container sme-container">
    <h1>Buy Policy</h1>

    <template >
      <div class="abs-top-right">
        <v-button @click="handleBack">Previous</v-button>
        <v-button
          type="primary"
          @click="handlerNext">Next
        </v-button>
      </div>
    </template>

    <div class="flex">
      <section class="flex-1 form-content">
        <catering-form
          ref="sme-form"
          :form="formData"
          :formDataLock="formDataLock"
          @getFormData="getFormData"></catering-form>

        <lazy-dom notLoading>
          <use-personal-data
            ref="use-personal-data"
            :marketing_data="formData.marketing_data"
            :company_name="formData.company_language"
            @sendData="getData"></use-personal-data>
        </lazy-dom>

      </section>
      <div class="right">
        <premium-side
          ref="premium-side"
          :customer-id="customer_id"
          :sidebar-info="sidebar_info"
          :form="formData"
          @updatePremium="updatePremium"></premium-side>
      </div>
    </div>

    <!--    <plan-dialog-->
    <!--      ref="plan-dialog"-->
    <!--      :planInfo="quote_coverage_list"/>-->

    <to-top :el='container'></to-top>
    <!--    <message-dialog-->
    <!--      ref='msg'-->
    <!--      @clearOptions='clearExtraOptions'></message-dialog>-->
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import {mapActions, mapState} from 'vuex'
import cateringForm from './sme/component/sme-form'
import premiumSide from './sme/component/preimum-side'
import {getSMEPolicyDetail, saveSMEKyc} from '@/api/sme'
import {smeClassId} from '@/utils/smePath'
import UsePersonalData from '@/views/components/use-personal-data'

export default {
  name: 'SMEBuyPolicyForm',
  components: {
    cateringForm,
    premiumSide,
    UsePersonalData
  },
  mixins: [MixinOptions, MixinFormat, MixinRules],
  data() {
    return {
      saveEdit: false,
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      sidebar_info: {},
      amount: '',
      formData: {
        less_verify_save: 0, // 是否僅保存部分資料（1：部分保存；0：全部保存   --标记是create 还是 edit
        policy_detail:{
          pcy_cmnt_dt:'',
          bus_hour:'',
          newly_com_ind:'',
          same_as_corr_addr_ind:'',
          insured_address:{
            addr_room: '',
            addr_floor: '',
            addr_block: '',
            addr_building: '',
            addr_street: '',
            addr_district: '',
            addr_area: '',
            addr_region: '',
          }
        },
        policyholder_detail:{
          isrd_com_nm:'',
          id_no:'',
          phone_no:'',
          email:'',
          corr_address:{
            addr_room: '',
            addr_floor: '',
            addr_block: '',
            addr_building: '',
            addr_street: '',
            addr_district: '',
            addr_area: '',
            addr_region: '',
          },
          contact_nm:'',
          contact_phone:''
        },
        other_info:{
          kinds_of_stocks:[],
          max_val_per_stocks:2,
          fire_sprinkler_ind:2,
          alarm_install_ind:2,
          wk_in_danger_pos_ind:2,
          wk_in_high_ind:2,
          wk_outside_hk_ind:2,
          use_hazardous_ind:2,
          prev_loss_ind:2,
        },
        upload_document:{
          br_files:[],
          mpf_files:[],
          renewal_files:[],
          device_files:[],
        }
      },
      code: '',
      planDialog: false,
      extraRules: {
      },
      container:null,
      customer_id:0,
      personalData: {}
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    ...mapState('account', ['customerId']),
    ...mapState('coupon', ['selectCode']),
    ...mapState('errorfield', ['errorField']),
    orderId() {
      return this.$route.query.order_id
    },
    classId(){
      let {type} = this.$route.params
      return smeClassId[type]||this.detailData.class_id
    },
    smeType(){
      let {type} = this.$route.params
      return type
    }
  },
  watch:{
  },
  created() {
    this.network().getSMEPolicyDetail()
  },
  mounted(){
    this.getElement()
  },
  methods: {
    ...mapActions('coupon', ['setCouponData', 'setSelectCode']),
    ...mapActions('errorfield', ['setErrorData']),
    ...mapActions('account', ['setCustomerId']),
    ...mapActions('common', ['setProductId']),
    updatePremium(){
      this.network().getSMEPolicyDetail(true)
    },
    handleBack(){
      this.$router.back()
    },
    planClick() {
      this.$refs['plan-dialog'].changeDialog()
    },
    handlerSetCode(data) {
      let {coupon, code, coupon_code, quote_coverage_list, referrer, referrer_id} = data
      let params = {}
      if (coupon_code) {
        params.coupon = {selectCode: 1, ...coupon}
      }
      if (code) {
        params.code = {selectCode: 2, code, referrer, referrer_id}
      }
      this.setSelectCode(params)

    },
    handlerGetAllQuote() {

    },
    getFieldData({key, value}) {
      this.$set(this.formData, key, value)
    },
    handlerApplyCode() {
      // if (!this.code) {
      //   this.$message({
      //     type: 'warning',
      //     message: '請輸入優惠碼'
      //   })
      //   return
      // }
      this.network().verifyPromoCode()

    },

    hanlerSave() {
      this.saveEdit = true

    },
    async handlerNext() {
      this.$refs['sme-form'].submitForm()
    },
    getFormData(data){
      this.network().saveSMEKyc(data)
    },
    getData(personalData){
      this.personalData = personalData
    },
    network() {
      return {
        getSMEPolicyDetail: async (updatePremium = false) => {
          let {data} = await getSMEPolicyDetail({
            order_id: this.orderId
          },this.classId)
          // 加個標記，組件監聽到變化才可以覆蓋組件裏的表單數據
          this.formDataLock += 1
          let {customer_id,class_id,sidebar_info,content_detail,policy_detail,policyholder_detail,other_info,upload_document} = data
          let params = {
            policy_detail,
            policyholder_detail,
            other_info,
            upload_document,
            class_id,
            content_detail
          }
          this.formData = Object.assign(this.formData, data)
          this.sidebar_info = sidebar_info
          this.customer_id = customer_id
          this.$refs['premium-side'].handlerSetCode()
        },
        saveSMEKyc: async (params) => {
          this.$refs['use-personal-data'].handleSendData()
          let {data} = await saveSMEKyc({
            order_id: this.orderId,
            ...params,
            customer_id: this.customer_id,
            marketing_data: this.personalData
          },this.classId)
          let {quotation_number} = data
          this.setProductId(this.classId)
          if (data.code && [4178, 4179].includes(data.code)) {
            this.$message({
              type: 'warning',
              message: data.message_language
            })
            // 存儲投保資料，創建 refer 要用
            this.setCustomerId(this.customer_id)
            this.$router.push({
              path:`/quoting/quote/${this.smeType}/refer/information`,
              query: {
                order_id: this.orderId,
                class_id: this.classId
              }
            })
          } else {
            this.$router.push({
              // path: '/quoting/payment',
              path: '/quoting/payment/success',
              query: {
                order_id: this.orderId,
                customer_id: this.customer_id,
                quote_no: quotation_number,
                class_id:this.classId
              }
            })
          }
        },
        verifyPromoCode: async () => {
          if (this.code) {
            const {data} = await verifyPromoCode({
              customer_id: this.customer_id,
              code: this.code
            })
            if (data.code == 1000) {
              this.network().applyOrderCode()
            }
          } else {
            this.network().applyOrderCode()
          }

        },
        applyOrderCode: async () => {
          let {selectCode, coupon = {}, code = {}} = this.selectCode || {}
          let params = {}
          if (coupon.selectCode == 1) {
            params.coupon = coupon.coupon_code
          }
          if (code.selectCode == 2) {
            params.code = code.code
          }
          const {dataCode} = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.customer_id,
            ...params
          })
          this.formData = Object.assign(this.formData, dataCode)
        },
      }
    },
    getElement(){
      this.container = this.$refs['container'].parentElement
    },
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  position: relative;
  padding: 15px;
  /deep/.el-date-editor.el-input {
    width: 100%;
  }
  //.form-content{
  //  width: calc(100% - 330px);
  //  ///deep/.policy-content{
  //  //  .address-form{
  //  //    width: 50%;
  //  //  }
  //  //}
  //}
  .extra_checkbox{
    ::v-deep .el-checkbox-group{
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .main-container {
    .eff-box {
      width: calc(50% - 10px);
    }

    .document-wrapper {
      .flex {
        .form-item {
          margin-right: 15px;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .drivers-file-container {
        position: relative;
        display: flex;
        flex-wrap: wrap;

        .card {
          position: relative;
          margin-bottom: 15px;
          width: calc(50% - 10px);

          &:nth-child(2n-1) {
            margin-right: 10px;
          }

          &:nth-child(2n) {
            margin-left: 10px;
          }

          .mask {
            z-index: 2;
            position: absolute;
            top: 40px;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(255, 255, 255, 0.7);
          }
        }
      }
    }
  }

  .right {
    margin-left: 15px;
    //min-width: 250px;
    //max-width: 250px;

    .company-logo {
      // display: flex;
      // justify-content: center;
      // align-items: center;
      // width: 78px;
      height: 42px;

      img {
        // width: 100%;
        // max-height: 100%;
        height: 42px;
      }
    }

    .label {
      display: block;
      margin: 10px 0;
      font-size: 16px;
      line-height: 19px;
      font-weight: bold;
    }

    .total-box {
      margin: 15px -15px -15px -15px;
      padding: 15px;
      background: #ecf5ff;

      span {
        display: block;
        color: #616266;
        font-size: 14px;
      }

      .amount {
        font-size: 24px;
        color: #409eff;
        font-weight: bold;
      }
    }
  }
  .margin-top-ten{
    margin-top: 10px;
  }
  .flex-algin{
    //align-items: center;
    margin-bottom: 10px;
    .label{
      margin-top: 0;
    }
    .icon{
      margin-right: 15px;
      height: 22px;
      width: 22px;
      color: #6A737D;
      border-radius: 5px;
      text-align: center;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
    }
  }

}
</style>
